import { Layers, PinDrop, Settings, SettingsOutlined, Straighten, ViewList } from "@mui/icons-material";

import { CORE_PANEL_IDS, DispatchSidePanels, sidePanelsActions } from "contexts/sidePanels";
import ObjectTreeIcon from "media/icons/object-tree.svg?react";
import PropertiesIcon from "media/icons/properties.svg?react";

import {
    AllItemsPanel,
    DeviationsPanel,
    DimensionSidePanel,
    GroupsPanel,
    ObjectsPanel,
    PropertiesPanel,
    SettingsPanel,
    ViewsMarkupsPanel,
} from "./panels";

/**
 * Register all built-in side panels.
 * Call this once during app initialization.
 */
export function registerCorePanels(dispatch: DispatchSidePanels) {
    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.VIEWS_MARKUPS,
            title: "Views & Markups",
            icon: <ViewList />,
            component: ViewsMarkupsPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.ALL_ITEMS,
            title: "All Items",
            icon: <PinDrop />,
            component: AllItemsPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.OBJECTS,
            title: "Objects",
            icon: <ObjectTreeIcon />,
            component: ObjectsPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.PROPERTIES,
            title: "Properties",
            icon: <PropertiesIcon />,
            component: PropertiesPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.GROUPS,
            title: "Groups",
            icon: <Layers />,
            component: GroupsPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.DEVIATIONS,
            title: "Deviations",
            icon: <Settings />,
            component: DeviationsPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.SETTINGS,
            title: "Settings",
            icon: <SettingsOutlined />,
            component: SettingsPanel,
        }),
    );

    dispatch(
        sidePanelsActions.registerPanel({
            id: CORE_PANEL_IDS.DIMENSION,
            title: "Dimension",
            icon: <Straighten />,
            component: DimensionSidePanel,
        }),
    );
}
